<template>
  <div class="">
    <select @change="languageFilter" class="form-control px-4" v-model="language">
      <option value="">مشاهده همه</option>
      <option v-for="language in languages" :value="language.slug">{{ language.name }}</option>
    </select>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "LanguageSelectBox",
  props: {
    moduleName: {
      default: 'Content'
    }
  },
  data() {
    return {
      language: this.findAttributeOnSiteInfo('default_language')[0].slug
    }
  },
  computed: {
    ...mapGetters({
      languages: 'Language/getLanguages'
    }),
    getModuleName() {
      let modelName = this.moduleName;
      return modelName.charAt(0).toUpperCase() + modelName.slice(1)
    }
  },
  methods: {
    languageFilter() {
      const modelName = this.getModuleName;
      const moduleLanguage = this.$store.getters[`${modelName}/getFilters`].language
      this.$store.commit(`${modelName}/setFilters`, {key: 'language', value: this.language})
      if (this.language != moduleLanguage) {
        this.$emit('changeLanguage', this.language)
      }

    },
  },
  mounted() {
    // initialize default language on model
    this.$store.commit(`${this.getModuleName}/setFilters`, {key: 'language', value: this.language})
  }
}
</script>

<style scoped>

</style>